import { render, staticRenderFns } from "./IvaConfirmationModal.vue?vue&type=template&id=7d2b2ab2"
import script from "./IvaConfirmationModal.vue?vue&type=script&lang=js"
export * from "./IvaConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports